// Material Kit 2 React base styles
// import colors from "assets/theme/base/colors";
import boxShadows from "assets/theme/base/boxShadows";
import borders from "assets/theme/base/borders";

// const { transparentColor } = colors;
const { lg } = boxShadows;
const { borderRadius } = borders;

export default {
  styleOverrides: {
    paper: {
      // backgroundColor: transparentColor.main,
      boxShadow: lg,
      borderRadius: borderRadius.md,
    },
  },
};
